import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import * as styles from "./styles/index.scss"
import bjImg from "@assets/img/seat/bj.png"
import kuang1 from "@assets/img/seat/kuang1.png"
import kuang2 from "@assets/img/seat/kuang2.png"
import touxiang from "@assets/img/seat/touxiang.png"
import buttonImg from "@assets/img/seat/buttonImg.png"
import { InputItem, Toast } from 'antd-mobile'
import { createForm } from 'rc-form';
// import VConsole from 'vconsole';
// let vConsole = new VConsole() //log调试
class SeatSystem extends ComponentExt<any, any> {
    private randomCode: string
    constructor(props) {
        super(props)
        document.title = '年会座位盲抽'
        this.randomCode = this.props.match.params.randomCode
        this.state = {
            showCode: false,
            fixedArray: [
                { name: '王帅', code: '1' }, { name: '邱润阳', code: '1' }, { name: '王云锋', code: '1' },
                { name: '廖畅', code: '1' }, { name: '梁晓辉', code: '1' }, { name: '张君毅', code: '1' },
                { name: '黄礼成', code: '1' }, { name: '高旭辉', code: '1' }, { name: '刘嘉瑞', code: '1' },
                { name: '柁亚超', code: '1' }, { name: '李哲', code: '1' }, { name: '李波', code: '1' },
                { name: '锁良晨', code: '1' }, { name: '牛晓涛', code: '1' }, { name: '孙利', code: '1' },

                { name: '周利军', code: '2' }, { name: '王恒婷', code: '2' }, { name: '黄泰华', code: '2' },
                { name: '刘皓', code: '2' }, { name: '刘晓晶', code: '2' }, { name: '丁雪峰', code: '2' },
                { name: '陈荣波', code: '2' }, { name: '王金豹', code: '2' }, { name: '张琳福', code: '2' },
                { name: '倪晓林', code: '2' }, { name: '王志丹', code: '2' }, { name: '冯玫', code: '2' },
                { name: '郭瑞丰', code: '2' }, { name: '宋涵', code: '2' }, { name: '陈丽燕', code: '2' },

                { name: '邢海洋', code: '3' }, { name: '廖鑫', code: '3' }, { name: '方楚鹏', code: '3' },
                { name: '张隐萱', code: '3' }, { name: '林凯平', code: '3' },
                { name: '陈金娟', code: '3' }, { name: '徐淮杰', code: '3' }, { name: '赵晏', code: '3' },
                { name: '翟鸿鹏', code: '3' }, { name: '李裕', code: '3' }, { name: '高林', code: '3' },
                { name: '苏喜江', code: '3' }, { name: '王镇荣', code: '3' }, { name: '郑海叶', code: '3' },

                { name: '赵晨', code: '4' }, { name: '纪鹤', code: '4' },

                { name: '方冠玉', code: '5' }, { name: '周萌', code: '5' }, { name: '丽莎', code: '5' },
                { name: '李瑞东', code: '5' }, { name: '王欢', code: '5' }, { name: '王珂', code: '5' },

                { name: '边毅', code: '6' }, { name: '姚怡', code: '6' }, { name: '李文权', code: '6' },

                { name: '李晶洁', code: '7' }, { name: '孙宇', code: '7' },

                { name: '李锐', code: '8' }, { name: '黄华林', code: '8' },

                { name: '甄子华', code: '9' }, { name: '李毅华', code: '9' }, { name: '李亚男', code: '9' },
                { name: '彭备', code: '10' }, { name: '隗娟', code: '10' },

                { name: '曲晓光', code: '11' }, { name: '黄晓华', code: '11' },

                { name: '陈丹', code: '12' }, { name: '黄志鹏', code: '12' },

                { name: '杨玺', code: '13' }, { name: '张宁铃', code: '13' },

                { name: '汪洋', code: '14' }, { name: '沈中林', code: '14' },

                { name: '李桦', code: '15' }, { name: '张月', code: '15' }, { name: '郑敏红', code: '15' },
                { name: '慕林佳', code: '15' }, { name: '林妍', code: '15' }, { name: '吴盈盈', code: '15' },
                { name: '刘李杰', code: '15' }, { name: '胡嘉琪', code: '15' }, { name: '黄钰深', code: '15' },
                { name: '雷茜茜', code: '15' }, { name: '吴键武', code: '15' },

                { name: '谢雪斌', code: '16' }, { name: '郭茜铭', code: '16' },

                { name: '许卫佳', code: '17' }, { name: '火辉彩', code: '17' }, { name: '叶大满', code: '17' }, { name: '王豫', code: '17' },



            ],
            randomArray: [
                { name: '武利平', code: '' },
                { name: '吴斌彬', code: '' }, { name: '代锋', code: '' }, { name: '宋中容', code: '' },
                { name: '侯英华', code: '' }, { name: '陈楚仪', code: '' }, { name: '黄娟', code: '' },
                { name: '林美闪', code: '' }, { name: '张国良', code: '' }, { name: '谢春苗', code: '' },
                { name: '钟创灿', code: '' }, { name: '孙河云', code: '' }, { name: '李土添', code: '' },
                { name: '何俊豪', code: '' }, { name: '张玉东', code: '' }, { name: '李珠帅', code: '' },
                { name: '胡武名', code: '' }, { name: '陈诚', code: '' }, { name: '罗勇', code: '' },
                { name: '占学志', code: '' }, { name: '覃海涛', code: '' }, { name: '洪钊桦', code: '' },
                { name: '钟理', code: '' }, { name: '刘志辉', code: '' }, { name: '刘俊', code: '' },
                { name: '刘琼琼', code: '' }, { name: '王淯霖', code: '' }, { name: '方仕坚', code: '' },
                { name: '陈小林', code: '' }, { name: '吴泽伟', code: '' }, { name: '陈观宏', code: '' },
                { name: '李飞', code: '' }, { name: '戴炜源', code: '' }, { name: '宋茂生', code: '' },
                { name: '谭友强', code: '' }, { name: '罗小娟', code: '' }, { name: '刘巧慧', code: '' },
                { name: '郭丽娜', code: '' }, { name: '董洁', code: '' }, { name: '张子静', code: '' },
                { name: '华艳', code: '' }, { name: '曾欢', code: '' }, { name: '纪宝双', code: '' },
                { name: '江晓岚', code: '' }, { name: '任哲', code: '' }, { name: '丁小伟', code: '' },
                { name: '许道忆', code: '' }, { name: '徐文彬', code: '' }, { name: '丘绮雯', code: '' },
                { name: '胡琦', code: '' }, { name: '邓智杰', code: '' }, { name: '肖云芙', code: '' },
                { name: '王婧', code: '' }, { name: '林业柱', code: '' }, { name: '杨发堂', code: '' },
                { name: '胡梓泰', code: '' }, { name: '黄国针', code: '' }, { name: '侯晓萍', code: '' },
                { name: '许玉点', code: '' }, { name: '高明明', code: '' }, { name: '李祖慜', code: '' },
                { name: '刘培基', code: '' }, { name: '刘佳', code: '' }, { name: '梁林', code: '' },
                { name: '陈志鹏', code: '' }, { name: '童善斌', code: '' }, { name: '肖艳', code: '' },
                { name: '江金泉', code: '' }, { name: '黎永基', code: '' }, { name: '郑永发', code: '' },
                { name: '曾武', code: '' }, { name: '蒋智', code: '' }, { name: '周琼', code: '' },
                { name: '陈玉婷', code: '' }, { name: '梁敏怡', code: '' }, { name: '白飞荣', code: '' },
                { name: '游红', code: '' }, { name: '杨昊', code: '' }, { name: '蔡轶佳', code: '' },
                { name: '许小敏', code: '' }, { name: '梁毅敏', code: '' }, { name: '李肖儿', code: '' },
                { name: '何淑芳', code: '' }, { name: '周军', code: '' }, { name: '梁竞', code: '' },
                { name: '刘泓亮', code: '' }, { name: '黎祖铭', code: '' }, { name: '林俊言', code: '' },
                { name: '万冬前', code: '' }, { name: '黄敏义', code: '' }, { name: '宋力龙', code: '' },
                { name: '蓝嘉英', code: '' }, { name: '颜慧冰', code: '' }, { name: '汤佳源', code: '' },
                { name: '李凤怡', code: '' }, { name: '樊聪', code: '' }, { name: '许冬林', code: '' },
                { name: '寇周刚', code: '' }

            ],
            newRandomArray: [],
            myCode: '',
            myName: ''
        }
    }


    doSubmit = () => {
        this.props.form.validateFields(async (error, value) => {
            if (!error) {
                if (!value.name) {
                    Toast.info('请输入您的姓名');
                } else {
                    let check = false;
                    this.state.fixedArray.map((item) => {
                        if (item.name == value.name) {
                            this.setState({
                                myName: value.name,
                                myCode: item.code,
                                showCode: true
                            })
                            check = true;
                            return
                        }
                    })
                    if (!check) {
                        this.state.newRandomArray.map((item) => {
                            if (item.name == value.name) {
                                let code: any;
                                if (item.code >= 1 && item.code <= 8) {
                                    code = 4
                                } else if (item.code >= 9 && item.code <= 12) {
                                    code = 5
                                } else if (item.code >= 13 && item.code <= 19) {
                                    code = 6
                                } else if (item.code >= 20 && item.code <= 27) {
                                    code = 7
                                } else if (item.code >= 28 && item.code <= 35) {
                                    code = 8
                                } else if (item.code >= 36 && item.code <= 42) {
                                    code = 9
                                } else if (item.code >= 43 && item.code <= 50) {
                                    code = 10
                                } else if (item.code >= 51 && item.code <= 58) {
                                    code = 11
                                } else if (item.code >= 59 && item.code <= 66) {
                                    code = 12
                                } else if (item.code >= 67 && item.code <= 74) {
                                    code = 13
                                } else if (item.code >= 75 && item.code <= 82) {
                                    code = 14
                                } else if (item.code >= 83 && item.code <= 90) {
                                    code = 16
                                } else if (item.code >= 91) {
                                    code = 17
                                }

                                this.setState({
                                    myName: value.name,
                                    // myCode: item.code >= 12 ? item.code + 4 : item.code + 3,
                                    myCode: code,
                                    showCode: true
                                })
                                check = true;
                                return
                            }
                        })
                    }
                    if (!check) {
                        Toast.info('系统未查到姓名信息，请联系管理员');
                    }
                }
            } else {
                Toast.info('系统异常请联系管理员');
            }
        })
    };
    getUrlParam(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let url = window.location.href.split('#')[0]
        let search = url.split('?')[1]
        if (search) {
            var r = search.substr(0).match(reg)
            if (r !== null)
                return unescape(r[2])
            return null
        } else
            return null
    }

    //线性同余生成器（LCG, Linear Congruential Generator)
    shuffleArray(array, seed) {
        let indices = new Array(array.length);
        for (let i = 0; i < indices.length; i++) {
            indices[i] = i;
        }

        // 根据种子生成伪随机数序列
        for (let i = 0; i < array.length; i++) {
            let rand = (seed * 9301 + 49297) % 233280;
            seed = rand;
            let j = Math.floor(rand / (233280.0 / array.length));
            [indices[i], indices[j]] = [indices[j], indices[i]];
        }

        // 根据索引数组重新排列数组
        let shuffledArray = new Array(array.length);
        for (let i = 0; i < array.length; i++) {
            shuffledArray[i] = array[indices[i]];
            // shuffledArray[i].code = Math.ceil((i + 1) / 8)
            shuffledArray[i].code = i + 1 //直接从1开始排序，每个位置人数不一定，需要在下一步进行具体排序座位
        }
        console.log('shuffledArray', shuffledArray)
        this.setState({
            newRandomArray: shuffledArray
        })
        return shuffledArray;
    }


    async componentDidMount() {
        document.title = '年会座位盲抽'
        // sessionStorage.setItem("unionid", 'op8inw3QVZDf92jQRWlRSNRIeQWQ');
        // sessionStorage.setItem("nickname", 'Damon');
        // sessionStorage.setItem("headimgurl", 'https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eq1QcicWB6J93zicIAlNLE1yEtzW5RwF38uVHvCfljY1KdEF03ND8ngGKstx16Lk3et3q1rvySKkqOQ/132');

        const code = this.getUrlParam('code')  // 截取路径中的code
        if ((code == null || code === '') && !sessionStorage.getItem('unionid')) {
            const local = window.location.href
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6f5057302da09451&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect';
        } else if (!sessionStorage.getItem('unionid')) {
            const res = await this.api.getOpenId({ code }) //把code传给后台获取用户信息
            // 本地存储这个unionid，并刷新页面
            sessionStorage.setItem("unionid", res.unionid);
            sessionStorage.setItem("nickname", res.nickname);
            sessionStorage.setItem("headimgurl", res.headimgurl);
            location.reload();
        } else if (sessionStorage.getItem('unionid')) {
            this.setState({ showCode: false })
        }

        const seed = this.randomCode; // 我们要用任意值来打乱数组
        const shuffled = this.shuffleArray(this.state.randomArray, seed);
        // console.log(shuffled); // 将打印出一个根据任意值作为混乱种子排序的数组
    }




    render(): React.ReactNode {
        const { getFieldProps } = this.props.form;
        return (
            <>
                <div className={styles.seatWrapper}
                >
                    <div className={styles.bjContent}>
                        <img className={styles.bjImg} src={bjImg} alt="" />


                        {!this.state.showCode && (
                            <div className={styles.loginCotent}
                            >
                                <img className={styles.kuang1} src={kuang1} alt="" />
                                <InputItem
                                    {...getFieldProps('name',)}
                                    placeholder={'请输入您的姓名'}
                                    className={styles.inputName}
                                />
                                <img className={styles.submitName} src={buttonImg} alt="" onClick={this.doSubmit} />
                            </div>
                        )}
                        {this.state.showCode && (
                            <div className={styles.numberCotent}>
                                {sessionStorage.getItem('headimgurl') && (
                                    <div className={styles.touxiang}>
                                        <img className={styles.touxiangImg} src={sessionStorage.getItem('headimgurl')} alt="" />
                                        <img className={styles.touxiangBorder} src={touxiang} alt="" />
                                    </div>
                                )}
                                <div className={styles.nameShow}>
                                    <div className={styles.nameText1}>嘉宾</div> <div className={styles.nameText2}>{this.state.myName}</div> <div className={styles.nameText1}>晚上好</div>
                                </div>
                                <div className={styles.numberShow}>
                                    <div className={styles.numberText1}>{this.state.myCode}</div>
                                    <div className={styles.numberText2}>您的桌号</div>
                                </div>

                                <img className={styles.kuang2} src={kuang2} alt="" />

                            </div>
                        )}
                    </div>

                </div>

            </>

        )
    }
}
export default createForm()(SeatSystem)